import React, {useCallback} from 'react';
import {PersonMetaParams} from 'module/Person/api/PersonAPI'
import {usePersonSlctOptions} from 'module/Person/hook/usePersonSlctOptions'
import {Slct} from 'module/Slct/component/Slct'
import {filterOptionsSlct} from 'module/Slct/util/filterOptionsSlct'
import {SlctProps} from 'module/Slct/type/SlctType'
import {SetCb} from 'type/SetCb'
import {Person} from 'generated/JavaTOmodifications'

export interface PersonSelectComponentProps extends Pick<SlctProps<Person, number>, 'placeholderHTML' | 'menuWidth' | 'memo'> {
	persNr: number | null,
	personMetaParams?: PersonMetaParams
	onChange: SetCb<number | null>
	disabled?: boolean
	autoFocus?: boolean
	className?: string
}

export function PersonSelectComponent(props: PersonSelectComponentProps) {
	const {persNr, onChange: _onChange, personMetaParams, disabled, className, autoFocus} = props
	const {options, loading} = usePersonSlctOptions(personMetaParams)
	const onChange: SlctProps<Person, number>['onChange'] = useCallback((opt) => {
		const v = opt && opt.value || null;
		_onChange(v)
	}, [_onChange])
	return <Slct
		value={persNr}
		options={options}
		onChange={onChange}
		loading={loading}
		disabled={disabled}
		filterOptions={filterOptionsSlct}
		autoFocus={autoFocus}
	/>
}